export default __webpack_public_path__ + "static/media/logo.3294869c.svg";